module.exports = __webpack_public_path__ + "static/media/bold.64c7e48b.svg";